import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgMaterialSymbolsPause = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path fill="currentColor" d="M14 19V5h4v14zm-8 0V5h4v14z" />
  </svg>
);
const ForwardRef = forwardRef(SvgMaterialSymbolsPause);
const Memo = memo(ForwardRef);
export default Memo;
